<template>
    <div class="header-continer">
        <i id="arrow" class="material-icons" @click="handleBack">arrow_back</i>
        <Header></Header>
    </div>
    <div class="menu-container">
        <Banner></Banner>
        <h1 id="title-up-category">I nostri piatti</h1>
        <div class="category-container">
            <DailyMenuBanner v-if="dailyMenuIsThere"></DailyMenuBanner>
            <ItemCategoryFullWidth v-if="fullMenu" class="item-category-fullWidth" :backgroundImage="fullCategory.backgroundimage"
                :title="fullCategory.title" @category-click="goToCategory" />
            <ItemCategory class="item-category" v-for="(category, index) in categories" :key="index"
                :backgroundImage="category.backgroundimage" :title="category.title" @category-click="goToCategory" />
        </div>

    </div>
    <LoadingAnimation v-if="loading"></LoadingAnimation>
</template>

<script>
import { fetchAllCategories } from '@/api/CategoryAPI'
import { checkIfMenuExists } from '@/api/DailyMenuAPI'
import Header from '@/components/homepage/Header'
import Banner from '@/components/homepage/Banner'
import ItemCategory from '@/components/menupage/ItemCategory'
import LoadingAnimation from '@/components/generic/LoadingAnimation.vue'
import ItemCategoryFullWidth from '@/components/menupage/ItemCategoryFullWidth.vue'
import DailyMenuBanner from '@/components/generic/DailyMenuBanner'

export default {
    components: {
        Header,
        Banner,
        ItemCategory,
        ItemCategoryFullWidth,
        LoadingAnimation,
        DailyMenuBanner,
    },
    async mounted() {
        this.loading = true;
        this.dailyMenuIsThere = await checkIfMenuExists();
        this.categories = await fetchAllCategories();
        this.loading = false;
    },
    methods: {
        async goToCategory(categoryTitle) {
            try {
                this.$router.push({ name: 'CategoryPage', params: { title: categoryTitle } });
            } catch (error) {
                console.error('Error navigating to category:', error);
            }
        },
        handleBack() {
            this.$router.go(-1);
        }
    },
    data() {
        return {
            categories: [],
            loading: false,
            fullCategory: {
                backgroundimage: 'https://firebasestorage.googleapis.com/v0/b/storage-image-app-menu.appspot.com/o/sapori-miei-storage%2F422161_result_rotated_002.webp?alt=media&token=b5a92eaf-e95b-4eff-ac9e-207140e70c2a',
                title: 'Menu completo'
            },
            dailyMenuIsThere: false,
            fullMenu: false
        }
    }

}
</script>
<style>
#arrow {
    font-size: 40px;
    color: var(--text-color);
    position: fixed;
    left: 10px;
    top: 10px;
    z-index: 1000;
}

.menu-container {
    background-color: var(--background-color);
    min-height: 100vh;
    padding-top: 10px;
}

#title-up-category {
    color: var(--text-color);
    text-align: center;
    margin: 40px;
    font-size: 40px;
}

.header-continer {
    text-align: center;
}

.category-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.item-category {
    width: calc(50% - 20px);
    margin: 8px;
    margin-bottom: 15px;
}

.item-category-fullWidth {
    margin: 8px;
    margin-bottom: 15px;
    width: calc(95% - 20px);

}
</style>